import React, { useState, useEffect } from 'react';
import { Button, Form, Upload, Modal, App, Tabs,Input,Menu, Select, Table, Pagination } from 'antd';
import type { GetProp, MenuProps } from 'antd';
import { PlusOutlined, DragOutlined, EyeOutlined } from '@ant-design/icons';
import { DragDropContext, Droppable, Draggable } from '@hello-pangea/dnd';
import styles from './StorePublishProductStep4.module.scss';
import type { UploadFile, UploadProps } from 'antd';
import { saveProduct,productTemplateSave,getProductTemplateList, getProductListStore, getProductDetail } from '@/api/products';
import { getServiceProductPageListByKeyword } from "@/api/Services"
import { useAppSelector } from '@/store/hooks';
import { useNavigate } from 'react-router-dom';
import RichTextEditor from '@/components/RichTextEditor';
import { IFormDataAll } from '../../types';
import ProductDetailTemplate1 from '../Template/ProductDetailTemplate1/ProductDetailTemplate1';
import ProductDetailTemplate2 from '../Template/ProductDetailTemplate2/ProductDetailTemplate2';
import ProductDetailTemplate3 from '../Template/ProductDetailTemplate3/ProductDetailTemplate3';
import ProductDetailTemplate4 from '../Template/ProductDetailTemplate4/ProductDetailTemplate4';
import ProductDetailTemplate5 from '../Template/ProductDetailTemplate5/ProductDetailTemplate5';
import ProductDetailTemplate6 from '../Template/ProductDetailTemplate6/ProductDetailTemplate6';
import ProductDetailTemplate7 from '../Template/ProductDetailTemplate7/ProductDetailTemplate7';
import ProductDetailTemplate8 from '../Template/ProductDetailTemplate8/ProductDetailTemplate8';
import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';


type MenuItem = GetProp<MenuProps, 'items'>[number];

// 模板渲染组件
interface TemplateRendererProps {
  template: any;
  index: number;
  onTemplateChange: (data: any, index: number) => void;
  editable?: boolean;
  thumbnailMode?: boolean;
  onDelete?: (index: number) => void;
}

const TemplateRenderer: React.FC<TemplateRendererProps> = ({
  template,
  index,
  onTemplateChange,
  editable = true,
  thumbnailMode = false,
  onDelete,
}) => {
  if (template.name === 'template1') {
    return <ProductDetailTemplate1
      thumbnailMode={thumbnailMode}
      data={template}
      editable={editable}
      selfIndex={index}
      onChange={(data, i) => onTemplateChange(data, i)}
      onDelete={(i) => onDelete && onDelete(i)}
    />;
  } else if (template.name === 'template2') {
    return <ProductDetailTemplate2
      thumbnailMode={thumbnailMode}
      data={template} 
      editable={editable} 
      selfIndex={index} 
      onChange={(data, i) => onTemplateChange(data, i)}
      onDelete={(i) => onDelete && onDelete(i)}
      
    />;
  } else if (template.name === 'template3') {
    return <ProductDetailTemplate3
    thumbnailMode={thumbnailMode}
    data={template} 
    editable={editable} 
    selfIndex={index} 
    onChange={(data, i) => onTemplateChange(data, i)} 
    onDelete={(i) => onDelete && onDelete(i)}
    />;
  } else if (template.name === 'template4') {
    return <ProductDetailTemplate4
      thumbnailMode={thumbnailMode}
      data={template} 
      editable={editable} 
      selfIndex={index} 
      onChange={(data, i) => onTemplateChange(data, i)}
      onDelete={(i) => onDelete && onDelete(i)} 
    />;
  } else if (template.name === 'template5') {
    return <ProductDetailTemplate5
      thumbnailMode={thumbnailMode}
      data={template} 
      editable={editable} 
      selfIndex={index} 
      onChange={(data, i) => onTemplateChange(data, i)}
      onDelete={(i) => onDelete && onDelete(i)} 
    />;
  } else if (template.name === 'template6') {
    return <ProductDetailTemplate6
      thumbnailMode={thumbnailMode}
      data={template} 
      editable={editable} 
      selfIndex={index} 
      onChange={(data, i) => onTemplateChange(data, i)}
      onDelete={(i) => onDelete && onDelete(i)} 
    />;
  } else if (template.name === 'template7') {
    return <ProductDetailTemplate7
      thumbnailMode={thumbnailMode}
      data={template} 
      editable={editable} 
      selfIndex={index} 
      onChange={(data, i) => onTemplateChange(data, i)}
      onDelete={(i) => onDelete && onDelete(i)} 
    />;
  } else if (template.name === 'template8') {
    return <ProductDetailTemplate8
      thumbnailMode={thumbnailMode}
      data={template}
      editable={editable}
      selfIndex={index}
      onChange={(data, i) => onTemplateChange(data, i)}
      onDelete={(i) => onDelete && onDelete(i)}
    />;
  }
  return null;
};


export interface StorePublishProductStep4Props {
  onNext?: (submitData: any) => void;
  onPrev?: () => void;
  formData?: IFormDataAll;
  independent?: boolean;//是否独立模式
}

//模板列表
const templateList = [
  {
    name: 'template1',
    title: 'Lightweight and portable',
    content: 'The lightweight structure makes it easy to use at home or on the go, adding convenience to your everyday life.',
    imgUrl: [
      {
        url: "https://www.easysolarsupply.com/api/upload_files/090c1c01851c44b69769e3294beba6ba.png",
        name: "",
      },
    ]
  },
  {
    name: 'template2',
    title: 'Handwoven with care',
    content: 'Each basket is carefully handwoven by skilled artisans, offering both durability and a unique, natural charm.',
    imgUrl: [
      {
        url: "https://www.easysolarsupply.com/api/upload_files/090c1c01851c44b69769e3294beba6ba.png",
        name: "",
      },
    ]
  },
  {
    name: 'template3',
    bottomTitle: 'Dominique Galvan',
    contentList: [
      {
        title: 'Dominique Galvan',
        content: 'Dominique Galvan ',
      },
      {
        title: 'Dominique Galvan',
        content: 'Dominique Galvan ',
      },
      {
        title: 'Dominique Galvan',
        content: 'Dominique Galvan ',
      },
    ],
    imgUrl: [
      {
        url: "https://test.townloop.app:8002/api/web/files/uploads/images/97037a89-252e-4d5b-bbab-2848b433174a.jpg",
        name: "",
      },
    ]
  },
  {
    name: 'template4',
    contentList: [
      {
        title: 'Square Storage Basket',
        content1: '13.78*9.84* 5.91',
        content2: 'Natural bamboo strips',
        imgUrl: [
          {
            url: "https://www.easysolarsupply.com/api/upload_files/090c1c01851c44b69769e3294beba6ba.png",
            name: "",
          },
        ]
      },
      {
        title: 'Striped Handheld Basket',
        content1: '13.78*9.84* 5.91',
        content2: 'Natural bamboo strips',
        imgUrl: [
          {
            url: "https://www.easysolarsupply.com/api/upload_files/090c1c01851c44b69769e3294beba6ba.png",
            name: "",
          },
        ]
      },
      {
        title: 'Dominique Galvan',
        content1: '13.78*9.84* 5.91',
        content2: 'Natural bamboo strips',
        imgUrl: [
          {
            url: "https://www.easysolarsupply.com/api/upload_files/090c1c01851c44b69769e3294beba6ba.png",
            name: "",
          },
        ]
      },
    ],

  },

  {
    name: 'template5',
    imgUrl: [
      {
        url: "https://www.easysolarsupply.com/api/upload_files/090c1c01851c44b69769e3294beba6ba.png",
        name: "",
      },
    ]
  },
  {
    name: 'template6',
    title: 'Dominique Galvan',
    contentList: [
      {
        leftTitle: 'Height:',
        rightTitle: '555mm',
      },
      {
        leftTitle: 'Length:',
        rightTitle: '1600mm',
      },
      {
        leftTitle: 'Material:',
        rightTitle: 'Acrylic',
      },
      {
        leftTitle: 'Size:',
        rightTitle: '2200x1200x720mm',
      },
    ],
  },
  {
    name: 'template7',
    title: 'Hand Woven Process',
    content: 'Crafted Weaves,Strict Checks',
    imgUrl: [

    ]
  },
  {
    name: 'template8',
    content: '<div><p>Crafted Weaves,Strict Checks</p></div>',
  },
];





// 产品发布第四步：详细描述和附件
const StorePublishProductStep4: React.FC<StorePublishProductStep4Props> = ({
  onPrev,
  formData,
  independent = false
}) => {
  const { message } = App.useApp();
  const [form] = Form.useForm();
  const navigate = useNavigate();
  // 富文本内容
  // const [productDescription, setProductDescription] = useState<string>('');
  const { t } = useTranslation();


  //产品详情模板内容
  const [productContent, setProductContent] = useState<any[]>([
  ]);

  // 预览模式状态
  const [isPreviewMode, setIsPreviewMode] = useState(false);

  // 文件上传相关状态
  const [fileList, setFileList] = useState<UploadFile[]>([]);
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewImage, setPreviewImage] = useState('');
  const [previewTitle, setPreviewTitle] = useState('');

  // 获取token
  const token = useAppSelector((state) => state.user.token);

  // 初始化数据
  useEffect(() => {
    if (formData) {
      // 设置富文本内容
      if (formData.product_content) {
        setProductContent(formData.product_content);
      }

      // 设置附件列表
      if (formData.product_media_list && formData.product_media_list.length > 0) {
        const attachments = formData.product_media_list
          .filter(item => item.product_media_type === 'attachment')
          .map((item, index) => ({
            uid: (item.id && (item.id + '')) || `-${index}`,
            file_id: item.id || null,
            name: `attachment-${index}`,
            status: 'done' as const,
            url: item.product_media_file_url,
            product_media_id: item.product_media_id || null
          }));

        setFileList(attachments);
      }
    }
  }, [formData]);




  // 处理提交
  const handleSubmit = () => {
    // 清理 formData，只保留需要的字段，避免包含事件对象
    const cleanFormData = {
      product_id: formData?.product_id || '',
      status: formData?.status || 1,
      is_delete: formData?.is_delete || false,
      product_category_id: formData?.product_category_id || null,
      product_category_brand_id: formData?.product_category_brand_id || null,
      product_spu_id: formData?.product_spu_id || null,
      product_title: formData?.product_title || '',
      product_status: formData?.product_status || 1,
      launch_option: formData?.launch_option || 'schedule',
      delivery_estimated_time: formData?.delivery_estimated_time || '24hours',
      delivery_method: formData?.delivery_method || 1,
      product_sku_values: formData?.product_sku_values || [],
      product_media_list: formData?.product_media_list || [],
      product_video_list: formData?.product_video_list || [],
      product_custom_attributes: formData?.product_custom_attributes || [],
      product_del_media_list: formData?.product_del_media_list || [],
      customize_SKU_attribute: formData?.customize_SKU_attribute || ''
    };
    debugger
    if(independent){
      console.log(333)
      // 没有对应的productid，弹窗选择
      setChooseVisible(true)
      return 
    }
    const submitData = {
      product_content: productContent,
    };

    const params = {
      ...cleanFormData,
      ...submitData
    };

    console.log('Form values:', params);

    saveProduct(params).then(res => {
      console.log('res:', res);
      if (res.code === 200) {
        message.success(t('showCase.Productsuccessfully'));
        navigate('/yourtownloop/yourProducts');
      } else {
        message.error(t('showCase.ProductFailed'));
      }
    });

  };

  // 返回上一步
  const handlePrev = () => {

    onPrev && onPrev();
  };

 

  // 处理模板内容变更
  const handleTemplateChange = (data: any, index: number) => {
    const newProductContent = [...productContent];
    newProductContent[index] = data;
    setProductContent(newProductContent);
  };

  //删除模板
  const handleDeleteTemplate = (index: number) => {
    const newProductContent = [...productContent];
    newProductContent.splice(index, 1);
    setProductContent(newProductContent);
  };

  // 拖拽排序处理
  const handleDragEnd = (result: any) => {
    if (!result.destination) {
      return;
    }

    const items = Array.from(productContent);
    const [reorderedItem] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, reorderedItem);

    setProductContent(items);
  };

  // 保存模板相关
 
  const [saveTemplateModalVisible,setSaveTemplateModalVisible] = useState<boolean>(false);

  const [form2] = Form.useForm();
  
  // 打开模板保存弹窗
  const handleSaveTemplate = () => {
    form2.resetFields();
    setSaveTemplateModalVisible(true);
    
  };

  // 模板保存
  const handleSaveTemplateAction = () =>{
    form2.validateFields().then(values => {
      console.log('values',values);

      console.log('productContent:', productContent);
      const params = {
        template_name:values.templateName,
        template_data:productContent
      };

      productTemplateSave(params).then(res => {
        if (res.code === 200) {
          message.success(t('showCase.Templatesuccessfully'));
          handleSaveTemplateCancel();
        } else {
          message.error(t('showCase.Templatefailed'));
        }
      })
    
    }).catch(errorInfo => {
      console.log('Failed:', errorInfo);
      message.error(t('showCase.Pleasefillintherequiredfields'));
    });
  }

  // 模板保存弹窗取消
  const handleSaveTemplateCancel = ()=>{
    setSaveTemplateModalVisible(false);
    form2.resetFields();
  }


  // 模板选择弹窗打开

  //待选择的基础模板
const menuItems: MenuItem[] = [

  {
    key: 'Specifications', 
    label: 'Product Specifications', 
    children: [
      { 
        key: 'template1', 
        label: 'Template 1', 
        onClick: () => handleSelectTemplateForPreview(templateList[0])
      },
      { 
        key: 'template2', 
        label: 'Template 2', 
        onClick: () => handleSelectTemplateForPreview(templateList[1])
      },
      { 
        key: 'template3', 
        label: 'Template 3', 
        onClick: () => handleSelectTemplateForPreview(templateList[2])
      },
      
    ],
  },

  {
    key: 'Material & Details', 
    label: 'Material & Details', 
    children: [
      // { 
      //   key: 'template4', 
      //   label: 'Template 4', 
      //   onClick: () => handleSelectTemplateForPreview(templateList[3])
      // },
      // { 
      //   key: 'template5', 
      //   label: 'Template 4', 
      //   onClick: () => handleSelectTemplateForPreview(templateList[4])
      // },
      { 
        key: 'template6', 
        label: 'Template 4', 
        onClick: () => handleSelectTemplateForPreview(templateList[5])
      },
      
    ],
  },


  

  
];


  const [templateSelectModalVisible,setTemplateSelectModalVisible] = useState<boolean>(false);
  const [activeTab, setActiveTab] = useState<string>('basic');

  // 用户保存的模板列表
  const [savedTemplates, setSavedTemplates] = useState<any[]>([
    {
      template_name:'template1',
      template_id:1,
      template_data:templateList.slice(0, 3)
    },
    {
      template_name:'template2',
      template_id:2,
      template_data:templateList.slice(3, 6)
    },
    {
      template_name:'template3',
      template_id:3,
      template_data:templateList.slice(6, 9)
    }
  ]);

  const [savedTemplateIndex, setSavedTemplateIndex] = useState<number>(-1);

  const [selectedTemplate, setSelectedTemplate] = useState<any[]>([]);
  const [previewTemplate, setPreviewTemplate] = useState<any[]>([]);



  // 获取保存的模板列表
  const loadSavedTemplates = async () => {
    try {
      const res = await getProductTemplateList({});
      if (res.code === 200) {
        setSavedTemplates(res.data || []);
      }
    } catch (error) {
      console.error(`${t('showCase.Failedloadsavedtemplates')}:`, error);
    }
  };

  // 打开模板选择弹窗
  const handleTemplateSelect = () => {
    setTemplateSelectModalVisible(true);
    loadSavedTemplates();
  };

  // 选择模板进行预览
  const handleSelectTemplateForPreview = (template: any,index?:number) => {
    console.log('template:', template);

    if(index !== undefined){
      setSavedTemplateIndex(index);
    }else{
      setSavedTemplateIndex(-1);
    }
    
    if(template && template.length > 0){
      setSelectedTemplate([ ...template]);
      setPreviewTemplate([...template]);
    }else{
      setSelectedTemplate([template]);
      setPreviewTemplate([template]);
    }
  };

  // 确认选择模板
  const handleConfirmSelectTemplate = () => {
    if (previewTemplate.length > 0) {
      // 如果是自定义模板，需要展开template_data
      setProductContent([...productContent, ...previewTemplate]);

      setTemplateSelectModalVisible(false);
      setSelectedTemplate([]);
      setPreviewTemplate([]);
    }
  };

  // 关闭模板选择弹窗
  const handleCloseTemplateSelect = () => {
    setTemplateSelectModalVisible(false);
    setSelectedTemplate([]);
    setPreviewTemplate([]);
  };

  // 选择商品或者服务
  const [chooseVisible,setChooseVisible] = useState<boolean>(false);
  const [chooseForm] = Form.useForm();
  const [chooseData,setChooseData] = useState<[]>([]);
  const chooseColumns = [
    {
    title: 'Product Name',
    dataIndex: 'product_title',
    key: 'product_title',
    
  },
  {
    title: 'Price',
    dataIndex: 'Price',
    key: 'Price',
    render: (val: any, row: any)=> {
      let price = ''
      if(Array.isArray(row.product_sku_values) && row.product_sku_values.length > 0){
        price = row.product_sku_values[0].product_price
      }
      return price ? `$${price}`: ''
    }
  },
  // {
  //   title: 'Inventory',
  //   dataIndex: 'Inventory',
  //   key: 'Inventory',
  // },
  {
    title: 'Creation Time',
    dataIndex: 'create_time',
    key: 'create_time',
    render: (val: any)=>{
      return val ? dayjs(val).format('YYYY/MM/DD HH:mm:ss') : ''
    }
  }
  ];
  const [pageParams, setPageParams] = useState({
    pageNum:1,
    pageSize:10,
    keyword:'',
    total:0,
  })
  const chooseOk = ()=>{
    console.log('chooseOk');
    console.log(selectedRowKeys);
    if(selectedRowKeys.length === 0){
      return message.warning(t('showCase.PleasechooseProductOrService'));
    }else{
      getProductDetail({ product_id: selectedRowKeys[0] }).then((res) => {
        console.log(res, 'res');
        if (res.code === 200) {
          res.data.product_category_id =
            res?.data?.product_category?.product_category_id || 0;

          res.data.product_category_brand_id =
            res?.data?.product_category_brand?.product_category_brand_id || 0;

          res.data.product_spu_id =
            res?.data?.product_spu?.product_spu_id || 0;

          let formData= res.data




              const cleanFormData = {
      product_id: formData?.product_id || '',
      status: formData?.status || 1,
      is_delete: formData?.is_delete || false,
      product_category_id: formData?.product_category_id || null,
      product_category_brand_id: formData?.product_category_brand_id || null,
      product_spu_id: formData?.product_spu_id || null,
      product_title: formData?.product_title || '',
      product_status: formData?.product_status || 1,
      launch_option: formData?.launch_option || 'schedule',
      delivery_estimated_time: formData?.delivery_estimated_time || '24hours',
      delivery_method: formData?.delivery_method || 1,
      product_sku_values: formData?.product_sku_values || [],
      product_media_list: formData?.product_media_list || [],
      product_video_list: formData?.product_video_list || [],
      product_custom_attributes: formData?.product_custom_attributes || [],
      product_del_media_list: formData?.product_del_media_list || [],
      customize_SKU_attribute: formData?.customize_SKU_attribute || ''
    };

    const submitData = {
      product_content: productContent,
    };

    const params = {
      ...cleanFormData,
      ...submitData
    };

    console.log('Form values:', params);

    saveProduct(params).then(res => {
      console.log('res:', res);
      if (res.code === 200) {
        message.success(t('showCase.Productsuccessfully'));
        setChooseVisible(false)
        // navigate('/yourtownloop/yourProducts');
      } else {
        message.error(t('showCase.ProductFailed'));
      }
    });
        }
      });
    }
  }

  const chooseCancel = ()=>{
    setChooseVisible(false);
    chooseForm.resetFields();
    setSelectedRowKeys([]);
    setChooseData([])
  }
  // 获取产品列表
  const getProductLists = async (val: any)=>{
    let res;
    if(val === 'Product'){
      res = await getProductListStore({
              page_num: pageParams.pageNum,
              page_size: pageParams.pageSize,
              keyword: pageParams.keyword?.trim() || '',
            });
    }else{
      res = await getServiceProductPageListByKeyword({
        pageNum: pageParams.pageNum,
        pageSize: pageParams.pageSize,
        ...(pageParams.keyword && pageParams.keyword.trim() ? { keyword: pageParams.keyword.trim() } : {})
      })
    }
    
    setPageParams({...pageParams,pageNum:res.pageNum,total:res.total})
    setChooseData(res.data)
    
  }
  const chooseChange = (val: any)=>{
    console.log(val)
  }

const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const onSelectChange = (newSelectedRowKeys: any) => {
  setSelectedRowKeys(newSelectedRowKeys);
};

// const clearSelection = () => {
//   setSelectedRowKeys([]);
// };

  return (
    <div className={styles['store-publish-product-step4']}>
      {!independent && (
        <div className={styles['main-title']}>{t('showCase.MultimediaListing')}</div>
      )}

      <Form form={form} layout="vertical">
       

        <div className={styles['section']}>
          <div className={styles['section-header']}>

          </div>

          <div className={styles['editor-layout']}>
            {/* 左侧模块选择器 */}
            {!isPreviewMode && (
              <div className={styles['module-selector']}>
                <div className={styles['module-selector-title']}>{t('showCase.AddModule')}</div>
                <div className={styles['module-buttons']}>
                  <Button
                    className={styles['module-btn']}
                    onClick={() => setProductContent([...productContent, templateList[7]])}
                  >
                    {t('showCase.Text')}
                  </Button>
                  <Button
                    className={styles['module-btn']}
                    onClick={() => setProductContent([...productContent, templateList[4]])}
                  >
                    {t('showCase.Image')}
                  </Button>
                  <Button
                    className={styles['module-btn']}
                    onClick={() => setProductContent([...productContent, templateList[6]])}
                  >
                    {t('showCase.Video')}
                  </Button>
                  <Button
                    className={styles['module-btn']}
                    onClick={handleTemplateSelect}
                  >
                    {t('showCase.Template')}
                  </Button>
                </div>
              </div>
            )}

            {/* 中间编辑区域 */}
            <div className={styles['editor-main']}>
              <div className={styles['editor-header']}>
                <div className={styles['editor-title']}>{t('showCase.MultimediaListing')}</div>
                <div className={styles['editor-instructions']}>
                 {t('showCase.DragReuse')}.
                </div>
                <div className={styles['editor-actions']}>
                  <Button className={styles['reset-btn']} onClick={() => setProductContent([])}>
                    {t('common.Reset')}
                  </Button>
                  <Button className={styles['save-template-btn']} onClick={() => handleSaveTemplate()}>
                    {t('showCase.SaveTemplate')}
                  </Button>
                </div>
              </div>

              <div className={styles['rich-editor-container']}>
                <DragDropContext onDragEnd={handleDragEnd}>
                  <Droppable droppableId="templates">
                    {(provided, snapshot) => (
                      <div
                        {...provided.droppableProps}
                        ref={provided.innerRef}
                        className={`${styles['droppable-area']} ${snapshot.isDraggingOver ? styles['drag-over'] : ''}`}
                      >
                        {productContent.map((item, index) => (
                          <Draggable
                            key={`${item.name}-${index}`}
                            draggableId={`${item.name}-${index}`}
                            index={index}
                            isDragDisabled={isPreviewMode}
                          >
                            {(provided, snapshot) => (
                              <div
                                ref={provided.innerRef}
                                {...provided.draggableProps}
                                className={`${styles['template-container']} ${snapshot.isDragging ? styles['dragging'] : ''}`}
                              >

                                <div {...provided.dragHandleProps}>
                                  <TemplateRenderer
                                    thumbnailMode={true}
                                    template={item}
                                    index={index}
                                    onTemplateChange={handleTemplateChange}
                                    onDelete={handleDeleteTemplate}
                                  />
                                </div>

                              </div>
                            )}
                          </Draggable>
                        ))}
                        {provided.placeholder}
                      </div>
                    )}
                  </Droppable>
                </DragDropContext>

                {productContent.length === 0 && (
                  <div className={styles['empty-state']}>
                    <div className={styles['empty-state-content']}>
                      <div className={styles['empty-state-icon']}>📝</div>
                      <div className={styles['empty-state-text']}>
                        {isPreviewMode ? t("showCase.Notemplatesaddedyet") : t("showCase.Clickdescription")}
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>

            {/* 右侧产品详情侧边栏 */}
            <div className={styles['product-details-sidebar']}>
              <div className={styles['sidebar-title']}>{t('showCase.ProductDetails')}</div>

              {/* 产品详情内容 */}
              <div className={styles['product-details-content']}>

                {productContent.map((item, index) => (
                  <TemplateRenderer
                    key={`sidebar-${item.name}-${index}`}
                    template={item}
                    index={index}
                    editable={false}
                    onTemplateChange={handleTemplateChange}
                  />
                ))}


              </div>
            </div>
          </div>
        </div>


        {/* 按钮区域 */}
        <div className={styles['button-container']} style={{justifyContent: independent ? 'flex-end' : 'space-between'}}>
         
          {!independent && (
            <Button
              className={styles['prev-button']}
              onClick={handlePrev}
            >
              {t('showCase.Prev')}
            </Button>
          )}
          <Button
            type="primary"
            className={styles['submit-button']}
            onClick={handleSubmit}
          >
            {t('common.submit')}
          </Button>
        </div>
      </Form>
      
       <Modal
         title={t('showCase.TemplateSelection')}
         open={templateSelectModalVisible}
         onCancel={handleCloseTemplateSelect}
         footer={null}
         width={1200}
         className={styles['template-select-modal']}
       >
         <div className={styles['template-modal-layout']}>
           {/* 左侧模板列表 */}
           <div className={styles['template-sidebar']}>
             <div className={styles['sidebar-header']}>
               <Tabs
                 activeKey={activeTab}
                 onChange={setActiveTab}
                 className={styles['template-tabs']}
                 items={[
                   {
                     key: 'basic',
                     label: t('showCase.BasicTemplate')
                   },
                   {
                     key: 'custom',
                     label: t('showCase.YourTemplate')
                   }
                 ]}
               />
             </div>
             
             <div className={styles['template-list']}>
               {activeTab === 'basic' ? (
                 <div className={styles['template-category']}>
                   <div className={styles['template-items']}>
                          <Menu
                            mode="inline"
                            items={menuItems}
                            className={styles['menu']}
                            defaultOpenKeys={['Specifications']}
                            selectedKeys={selectedTemplate.length > 0 ? [selectedTemplate[0]?.name] : []}
                          />
                   </div>
                 </div>
               ) : (
                 <div className={styles['template-category']}>
                   <div className={styles['category-title']}>{t('showCase.YourTemplates')}</div>
                   <div className={styles['template-items']}>
                       {savedTemplates.length > 0 ? (
                         savedTemplates.map((template, index) => (
                           <div
                             key={`custom-${template.template_id}`}
                             className={`${styles['template-list-item']} ${savedTemplateIndex === index ? styles['selected'] : ''}`}
                             onClick={() => handleSelectTemplateForPreview(template.template_data,index)}
                           >
                             {template.template_name}
                           </div>
                         ))
                     ) : (
                       <div className={styles['empty-templates']}>
                         <div className={styles['empty-text']}>{t('showCase.Nosavedtemplatesyet')}</div>
                       </div>
                     )}
                   </div>
                 </div>
               )}
             </div>
           </div>

           {/* 右侧预览区域 */}
           <div className={styles['template-preview-area']}>
             <div className={styles['preview-header']}>
               <div className={styles['preview-instruction']}>
                 {t('showCase.Youtemplatepreview')}.
               </div>
             </div>
             
             <div className={styles['preview-content']}>
               {previewTemplate && previewTemplate.length > 0 ? (
                 <div className={styles['template-preview-container']}>
                   {previewTemplate.map((template: any, index: number) => (
                     <TemplateRenderer
                       key={`preview-${template.name || template.template_id}-${index}`}
                       template={template}
                       index={index}
                       onTemplateChange={() => {}}
                       editable={false}
                       thumbnailMode={false}
                     />
                   ))}
                 </div>
               ) : (
                 <div className={styles['no-preview']}>
                   <div className={styles['no-preview-text']}> {t('showCase.Selecttemplatepreview')}</div>
                 </div>
               )}
             </div>
           </div>

           
         </div>

         {/* 底部操作按钮 */}
         <div className={styles['template-actions']}>
           <Button onClick={handleCloseTemplateSelect}>
             {t('membership.Cancel')}
           </Button>
           <Button
             type="primary"
             onClick={handleConfirmSelectTemplate}
             disabled={!previewTemplate}
             className={styles['select-btn']}
           >
             {t('showCase.AddTemplate')}
           </Button>
         </div>
       </Modal>

      <Modal
        title={t('showCase.EditTemplate')}
        open={saveTemplateModalVisible}
        onOk={handleSaveTemplateAction}
        onCancel={handleSaveTemplateCancel}
        okText={t('showCase.Save')}
        cancelText={t('membership.Cancel')}
        className={styles['edit-modal']}
      >
        <Form
          form={form2}
          layout="vertical"
        >
          <Form.Item
            label={t('showCase.TemplateName')}
            name="templateName"
            rules={[{ required: true, message: t('showCase.Pleaseentertemplatename') }]}
          >
            <Input placeholder="t('showCase.Entertemplatename')" maxLength={50} />
          </Form.Item>

          
        </Form>
      </Modal>

      <Modal
        title={t('showCase.ChooseProductOrService')}
        open={chooseVisible}
        onOk={chooseOk}
        onCancel={chooseCancel}
        okText={t('showCase.Save')}
        cancelText={t('membership.Cancel')}
        className={'choosePc'}
      >
        <Form
          form={chooseForm}
          layout="vertical"
        >
          <Form.Item
            label={t('showCase.Category')}
            name="Category"
            rules={[{ required: true, message: t('showCase.PleaseChooseCategory') }]}
          >
            <Select placeholder={t('showCase.PleaseChooseCategory')} options={[
              { value: 'Product', label: t('showCase.Product') },
              { value: 'Service', label: t('showCase.Service') },
            ]} onChange={(val)=>{
              setPageParams({...pageParams, pageNum:1})
              getProductLists(val)
              }} />
          </Form.Item>
          <Table dataSource={chooseData} columns={chooseColumns} pagination={{total:pageParams.total,pageSize:pageParams.pageSize,onChange(page,pageSize){
            console.log(chooseForm.getFieldValue('Category'))
            setPageParams({...pageParams, pageNum:page})
            getProductLists(chooseForm.getFieldValue('Category'))
          }}} rowSelection={{ type: 'radio', selectedRowKeys, onChange: onSelectChange  }} rowKey={'product_id'}/>
        </Form>
      </Modal>
    </div>
  );
};

export default StorePublishProductStep4; 